// extracted by mini-css-extract-plugin
export var changeIcon = "_75-4";
export var container = "_75-0";
export var divider = "_75-7";
export var externalLinkIcon = "_75-1";
export var green = "_75-5";
export var helpCircleIcon = "_75-3";
export var iconButton = "_75-2";
export var red = "_75-6";